import { Component, OnInit, Inject, ViewChild, HostListener } from "@angular/core";
import { StandardService } from "../services/standard.service";
import { Standard } from "../models/standard";
import { Router, ActivatedRoute } from "@angular/router";
import {
  Constant,
  StandardTypeEnum,
  StandardListType,
  UserRoleEnum,
  FilteringEnum,
  AllStandardsTabs,
  AddendumStatusEnum,
} from "../core/constant";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { FilteringGuide } from "../models/filteringGuide";
import { CryptographyService } from "../services/cryptography.service";
import { MatMenuTrigger } from "@angular/material/menu";
import { StandardList } from "../models/standard-list";
import { SelectedStandard } from "../models/selected-standard";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { Sort } from "@angular/material/sort";
import { CustomEventNRService } from "../services/custom-event-nr.service";
import { NrbesItem } from "../models/nrbesItem";
import { NrbesSet } from "../models/nrbesSet";
import { AddendumService } from "../services/addendum.service";
import { forkJoin } from "rxjs";
import * as XLSX from "xlsx";
declare var $: any;

interface StandardsTableRow {
  isNrbesRow: boolean;
  id: number;
  nrbesId?: number;
  title: string;
  standardTypeId: number;
  categoryName: string;
  description: string;
  newRestaurantDescription?: string;
  locationText: string;
  standard?: Standard;
  availabileAddendumId?: number;
  addendumStatusId?: number;
  countryId?: number;
  countryName?: string;
  nrbesItem?: NrbesItem;
}

@Component({
  selector: "app-view-all-minimum-standard-list",
  templateUrl: "./view-all-standards.component.html",
  styleUrls: ["./view-all-standards.scss"],
})
export class AllStandardsComponent implements OnInit {
  activePopupId: string | number | null = null;
  selectedTab: any;
  selectedRowsForExport: any[] = [];
  loading: boolean = false;
  selected = "option2";
  grses: Standard[] = [];
  nrbesItems: NrbesItem[] = [];
  standardsTableRows: StandardsTableRow[] = [];
  mergedTableRows: StandardsTableRow[] = [];
  error: string = "";
  pageSizes: any[] = Constant.PageSizes;
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;

  private _page: number = 1;
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
    this.standardService.allStandardsFiltration.startingIndex = value;
  }
  pageSize: number = 10;
  collectionSize: number = 0;
  totalPages: number = 0;
  userRole: number;
  userId: number;

  filterList: FilteringGuide[] = [];

  isPageEnabled: boolean = true;
  isFromLocation: boolean = false;
  searchKey: string = "";
  isDownloading: any = false;
  isTabWiseDownloading: boolean = false;
  exportSelectedIds: number[] = [];
  get userRoleEnum() {
    return UserRoleEnum;
  }
  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  get addendumStatusEnum() {
    return AddendumStatusEnum;
  }
  constructor(
    private standardService: StandardService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngbModal: NgbModal,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private cryptographyService: CryptographyService,
    private customEventNRService: CustomEventNRService,
    public addendumService: AddendumService,
  ) {
    //debugger;
    standardService.locationId =
      standardService.locationId == 0
        ? parseInt(this.activatedRoute.snapshot.paramMap.get("locationId"))
        : standardService.locationId;
  }

  ngOnInit() {
    // debugger;
    this.selectedTab = localStorage.getItem("selectedTabs");

    this.filterList = this.standardService.allStandardsFiltration.filterSet;
    void 0;
    if (!Number.isNaN(this.standardService.locationId)) {
      //debugger;
      this.setDefaultFiltration();
    }
    this.searchKey = this.standardService.allStandardsFiltration.searchKey;
    this.pageSize = this.standardService.allStandardsFiltration.pageSize;
    this._page = this.standardService.allStandardsFiltration.startingIndex || 1;
    this.userRole = this.getEffectiveUserRole();
    this.userId = this.cryptographyService.decryptData(
      this.storage.get("userId"),
    );
    this.loadData();
  }

  getEffectiveUserRole(): number {
    if (sessionStorage.getItem("userRoleId")) {
      return this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      );
    }
    return this.cryptographyService.decryptData(this.storage.get("userRole"));
  }

  isGlobalAdmin(): boolean {
    return this.getEffectiveUserRole() === UserRoleEnum.GlobalAdmin;
  }

  shouldShowStandardsRowActions(): boolean {
    return this.isGlobalAdmin() && !this.isMarketStandardsTab();
  }

  getImpersonationCountryId(): number | null {
    const sessionCountryId = sessionStorage.getItem("selectedCountryID");
    if (!sessionCountryId) {
      return null;
    }
    return Number(JSON.parse(sessionCountryId));
  }

  normalizeCountryIds(
    countryIds: number | number[] | null | undefined,
  ): number[] | null {
    if (countryIds == null) {
      return null;
    }
    if (Array.isArray(countryIds)) {
      return countryIds.length ? countryIds : null;
    }
    return [countryIds];
  }

  getEffectiveCountryIds(): number[] | null {
    const impersonationCountryId = this.getImpersonationCountryId();
    if (impersonationCountryId) {
      return [impersonationCountryId];
    }

    const filterCountryIds = this.normalizeCountryIds(
      this.standardService.allStandardsFiltration.countryId,
    );
    if (filterCountryIds) {
      return filterCountryIds;
    }

    const role = this.getEffectiveUserRole();
    if (
      role == UserRoleEnum.MarketAdmin ||
      role == UserRoleEnum.BasicUser
    ) {
      return this.normalizeCountryIds(
        this.cryptographyService.decryptData(this.storage.get("countryId")),
      );
    }

    return null;
  }

  selectedItemsPerPageChange(event) {
    this.page = 1;
    this.pageSize = event.value;
    this.standardService.allStandardsFiltration.pageSize = this.pageSize;
    if (
      this.shouldIncludeMarketStandardsInOperations() &&
      this.mergedTableRows.length
    ) {
      this.totalPages = Math.ceil(this.collectionSize / this.pageSize) || 1;
      this.updatePaginatedTableRows();
      return;
    }
    this.loadData();
  }

  onPageChange(page: number): void {
    this.page = page;
    if (
      this.shouldIncludeMarketStandardsInOperations() &&
      this.mergedTableRows.length
    ) {
      this.updatePaginatedTableRows();
      return;
    }
    this.loadData();
  }

  index = 0;
  getSelectedTabIds(): number[] {
    const tabsFilter =
      this.standardService.allStandardsFiltration.filterSet?.find(
        (i) => i.type == FilteringEnum.FilterByStandardType,
      );
    return tabsFilter?.ids ?? [];
  }

  isMarketStandardsTab(): boolean {
    return this.getSelectedTabIds().includes(AllStandardsTabs.MarketStandards);
  }

  /** Global Admin sees country on Market tab; keep visible when impersonating another role. */
  shouldShowMarketStandardsCountryColumn(): boolean {
    if (!this.isMarketStandardsTab()) {
      return false;
    }
    if (this.getEffectiveUserRole() === UserRoleEnum.GlobalAdmin) {
      return true;
    }
    return sessionStorage.getItem("impersonationView") === "true";
  }

  isBasicUser(): boolean {
    return this.getEffectiveUserRole() === UserRoleEnum.BasicUser;
  }

  isOperationsStandardsTab(): boolean {
    const tabIds = this.getSelectedTabIds();
    return (
      tabIds.length === 1 &&
      tabIds.includes(AllStandardsTabs.OperationsStandard)
    );
  }

  shouldIncludeMarketStandardsInOperations(): boolean {
    return this.isBasicUser() && this.isOperationsStandardsTab();
  }

  standardToTableRow(standard: Standard): StandardsTableRow {
    const standardData = standard as Standard & {
      availabileAddendumId?: number;
      addendumStatusId?: number;
    };
    return {
      isNrbesRow: false,
      id: standard.id,
      title: standard.title,
      standardTypeId: standard.standardTypeId,
      categoryName: standard.category?.name ?? "",
      description: standard.description,
      newRestaurantDescription: standard.newRestaurantDescription,
      locationText: this.getLocationNames(standard),
      standard,
      availabileAddendumId: standardData.availabileAddendumId,
      addendumStatusId: standardData.addendumStatusId,
    };
  }

  nrbesToTableRow(item: NrbesItem): StandardsTableRow {
    return {
      isNrbesRow: true,
      id: item.standard.id,
      nrbesId: item.id,
      title: item.standard.title,
      standardTypeId: item.standard.standardTypeId,
      categoryName: item.standard.category?.name ?? "",
      description: item.standard.description,
      locationText: this.getNrbesLocationNames(item),
      availabileAddendumId: item.availabileAddendumId,
      addendumStatusId: item.addendumStatusId,
      countryId: this.getNrbesCountryId(item),
      countryName: this.getNrbesCountryName(item),
      nrbesItem: item,
    };
  }

  supportsExceptionStandardType(standardTypeId: number): boolean {
    return (
      standardTypeId === StandardTypeEnum.GlobalMinimumRestaurantStandard ||
      standardTypeId === StandardTypeEnum.OperationsStandards
    );
  }

  showAddExceptionAction(row: StandardsTableRow): boolean {
    return (
      this.userRole === UserRoleEnum.GlobalAdmin &&
      this.supportsExceptionStandardType(row.standardTypeId) &&
      !row.availabileAddendumId
    );
  }

  showGoToExceptionAction(row: StandardsTableRow): boolean {
    return (
      this.userRole === UserRoleEnum.GlobalAdmin && !!row.availabileAddendumId
    );
  }

  showAddExceptionForNrbes(item: NrbesItem): boolean {
    return (
      this.userRole === UserRoleEnum.GlobalAdmin &&
      this.supportsExceptionStandardType(item.standard.standardTypeId) &&
      !item.availabileAddendumId
    );
  }

  showGoToExceptionForNrbes(item: NrbesItem): boolean {
    return (
      this.userRole === UserRoleEnum.GlobalAdmin && !!item.availabileAddendumId
    );
  }

  goToAddendumFromRow(row: StandardsTableRow, event: MouseEvent): void {
    event.stopPropagation();
    this.activePopupId = null;
    if (row.nrbesItem) {
      this.addendumService.isCommingFromNrbes = true;
      this.goToAddendum(row.nrbesItem);
      return;
    }
    if (row.availabileAddendumId) {
      this.router.navigate(["/addendum/" + row.availabileAddendumId]);
    }
  }

  addAddendumFromRow(row: StandardsTableRow, event: MouseEvent): void {
    this.activePopupId = null;
    this.addAddendum(row.id, event);
  }

  addAddendumFromNrbes(item: NrbesItem, event: MouseEvent): void {
    this.activePopupId = null;
    this.addAddendum(item.standard.id, event);
  }

  getNrbesCountryId(item: NrbesItem): number {
    if (Array.isArray(item.countryId) && item.countryId.length) {
      return item.countryId[0];
    }
    if (typeof item.countryId === "number") {
      return item.countryId;
    }

    const country = item.country as
      | { id?: number; name?: string }
      | Array<{ id?: number; name?: string }>
      | undefined;

    if (Array.isArray(country)) {
      return country[0]?.id ?? 0;
    }
    return country?.id ?? 0;
  }

  getNrbesCountryName(item: NrbesItem): string {
    const country = item.country as
      | { id?: number; name?: string }
      | Array<{ id?: number; name?: string }>
      | undefined;

    if (Array.isArray(country)) {
      return country[0]?.name ?? "";
    }
    return country?.name ?? "";
  }

  goToAddendumFromNrbes(item: NrbesItem, event: MouseEvent): void {
    event.stopPropagation();
    this.activePopupId = null;
    this.addendumService.isCommingFromNrbes = true;
    this.goToAddendum(item);
  }

  toggleNrbesPopup(event: MouseEvent, item: NrbesItem): void {
    event.stopPropagation();
    this.activePopupId = this.activePopupId === item.id ? null : item.id;
  }

  buildStandardsTableRows(): void {
    if (this.isMarketStandardsTab()) {
      this.mergedTableRows = [];
      this.standardsTableRows = this.nrbesItems.map((n) =>
        this.nrbesToTableRow(n),
      );
      return;
    }

    if (this.shouldIncludeMarketStandardsInOperations()) {
      this.mergedTableRows = [
        ...this.grses.map((s) => this.standardToTableRow(s)),
        ...this.nrbesItems.map((n) => this.nrbesToTableRow(n)),
      ];
      this.collectionSize = this.mergedTableRows.length;
      this.totalPages = Math.ceil(this.collectionSize / this.pageSize) || 1;
      this.updatePaginatedTableRows();
      return;
    }

    this.mergedTableRows = [];
    this.standardsTableRows = this.grses.map((s) => this.standardToTableRow(s));
  }

  updatePaginatedTableRows(): void {
    const start = (this.page - 1) * this.pageSize;
    this.standardsTableRows = this.mergedTableRows.slice(
      start,
      start + this.pageSize,
    );
  }

  onTableRowSelected(row: StandardsTableRow): void {
    if (row.isNrbesRow && row.nrbesId) {
      this.rowSelectedNrbes(row.nrbesId);
      return;
    }
    if (row.standard) {
      this.rowSelected(row.standard);
    }
  }

  getTableRowDescription(row: StandardsTableRow): string {
    const text = row.newRestaurantDescription || row.description || "";
    return this.extractDescription(text);
  }

  shouldShowMarketStandardsList(): boolean {
    return this.isMarketStandardsTab();
  }

  /** NRBES-backed rows hide checkboxes except on the Market Standards tab. */
  showStandardSelectionCheckbox(row: StandardsTableRow): boolean {
    if (!row.isNrbesRow) {
      return true;
    }
    return this.isMarketStandardsTab();
  }

  /** NRBES list rows share standard.id; selection must use the NRBES record id. */
  getRowSelectionKey(row: StandardsTableRow): number {
    if (row.isNrbesRow && row.nrbesId != null) {
      return row.nrbesId;
    }
    return row.id;
  }

  getCountryIdsForStandardsApi(): number[] | null {
    return this.getEffectiveCountryIds();
  }

  getCountryIdsForNrbesApi(): number[] {
    const countryIds = this.getEffectiveCountryIds();
    if (countryIds?.length) {
      return countryIds;
    }
    return [0];
  }

  getNrbesFilterList(): FilteringGuide[] {
    const filters = this.filterList.filter(
      (f) => f.type !== FilteringEnum.FilterByStandardType,
    );
    filters.push(
      new FilteringGuide({
        type: FilteringEnum.FilterByStandardType,
        ids: [
          StandardTypeEnum.LocalStandard,
          StandardTypeEnum.ABUStandard,
        ],
      }),
    );
    return filters;
  }

  getMarketStandardTypeLabel(item: NrbesItem): string {
    if (item.standard.standardTypeId === StandardTypeEnum.ABUStandard) {
      return "BU";
    }
    if (item.standard.standardTypeId === StandardTypeEnum.LocalStandard) {
      return "Market Standards";
    }
    return item.standard.standardType?.name ?? "";
  }

  loadData(): void {
    if (this.isMarketStandardsTab()) {
      this.getMarketStandards();
    } else if (this.shouldIncludeMarketStandardsInOperations()) {
      this.getStandardsWithMarketForBasicUser();
    } else {
      this.getStandards();
    }
  }

  getAppliedFilters() {
    let idx = this.standardService.allStandardsFiltration.filterSet.findIndex(
      (i) => i.type == FilteringEnum.FilterByStandardType,
    );
    if (idx == -1) {
      this.filterList.push(
        new FilteringGuide({
          type: FilteringEnum.FilterByStandardType,
          ids: [
            AllStandardsTabs.OperationsStandard,
            AllStandardsTabs.BuildingStandards,
            AllStandardsTabs.GlobalRecommendations,
            // AllStandardsTabs.AllStandards,
          ],
        }),
      );
      console.log("this.filter", this.filterList);
      this.standardService.allStandardsFiltration.filterSet = this.filterList;
      console.log(
        "test",
        this.standardService.allStandardsFiltration.filterSet,
      );

      // this.standardService.minimumStandardFiltration.filterSet =
      //   this.filterList;
      // this.standardService.sharedLearingsFiltration.filterSet = this.filterList;
      // this.standardService.equipmentStandardFiltration.filterSet =
      //   this.filterList;
      // this.standardService.operationsStandardFiltration.filterSet =
      //   this.filterList;
      return [
        AllStandardsTabs.OperationsStandard,
        AllStandardsTabs.BuildingStandards,
        AllStandardsTabs.GlobalRecommendations,
      ];
    }

    const filterIds =
      this.standardService.allStandardsFiltration.filterSet[idx].ids;

    // If "All Standards" is selected (IDs include AllStandards tab ID)
    if (filterIds.includes(AllStandardsTabs.AllStandards)) {
      // Return the actual IDs that represent "All Standards"
      // Based on your child component, AllStandards means [GlobalRecommendations, BuildingStandards, OperationsStandard]
      return [
        AllStandardsTabs.GlobalRecommendations,
        AllStandardsTabs.BuildingStandards,
        AllStandardsTabs.OperationsStandard,
      ];
    }

    return filterIds;
  }

  getStandards(): void {
    this.loading = true;
    this.nrbesItems = [];
    this.mergedTableRows = [];
    this.standardService
      .getAllStandards(
        (this.page - 1) * this.pageSize,
        this.pageSize,
        StandardListType.AllStandards,
        this.filterList,
        this.getCountryIdsForStandardsApi(),
        this.searchKey,
        this.getAppliedFilters(),
      )
      .subscribe((data: StandardList) => {
        void 0;
        if (data.standardDetailList != null)
          this.grses = data.standardDetailList.map((o) => new Standard(o));
        else this.grses = [];
        this.buildStandardsTableRows();
        if (this.searchKey) {
          this.customEventNRService.sendSearchEvent(
            "GrsSearchEvents",
            this.searchKey,
            this.grses.length,
            window.location.href,
          );
        }
        if (this.filterList.length > 1) {
          this.customEventNRService.sendFilterEvent(
            "Grsallfilters",
            JSON.stringify(this.filterList),
            this.grses.length,
          );
        }
        void 0;
        if (!this.shouldIncludeMarketStandardsInOperations()) {
          this.collectionSize = data.count;
          this.totalPages = Math.ceil(this.collectionSize / this.pageSize);
        }
        this.loading = false;
      }, (error: string) => {
        this.error = error;
        this.loading = false;
      });
  }

  getStandardsWithMarketForBasicUser(): void {
    this.loading = true;
    forkJoin({
      standards: this.standardService.getAllStandards(
        0,
        10000,
        StandardListType.AllStandards,
        this.filterList,
        this.getCountryIdsForStandardsApi(),
        this.searchKey,
        this.getAppliedFilters(),
      ),
      market: this.standardService.getNrbesByCountryId(
        this.userId,
        this.getCountryIdsForNrbesApi(),
        0,
        10000,
        this.getNrbesFilterList(),
        this.searchKey,
      ),
    }).subscribe({
      next: ({ standards, market }) => {
        this.grses =
          standards.standardDetailList?.map((o) => new Standard(o)) ?? [];
        this.nrbesItems = market.nrbes ?? [];
        this.buildStandardsTableRows();
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  getMarketStandards(): void {
    this.loading = true;
    this.grses = [];
    this.standardService
      .getNrbesByCountryId(
        this.userId,
        this.getCountryIdsForNrbesApi(),
        (this.page - 1) * this.pageSize,
        this.pageSize,
        this.getNrbesFilterList(),
        this.searchKey,
      )
      .subscribe((data: NrbesSet) => {
        this.nrbesItems = data.nrbes ?? [];
        this.collectionSize = data.count;
        this.totalPages = Math.ceil(this.collectionSize / this.pageSize);
        this.buildStandardsTableRows();
        if (this.searchKey) {
          this.customEventNRService.sendSearchEvent(
            "GrsSearchEvents",
            this.searchKey,
            this.collectionSize,
            window.location.href,
          );
        }
        this.loading = false;
      }, () => {
        this.loading = false;
      });
  }

  setDefaultFiltration() {
    this.standardService.allStandardsFiltration.filterSet = null;
    let locationFilteringGuide = new FilteringGuide();
    let filteringGuides = Array<FilteringGuide>();
    locationFilteringGuide.type = FilteringEnum.FilterByLocationType;
    locationFilteringGuide.ids.push(this.standardService.locationId);
    filteringGuides.push(locationFilteringGuide);
    this.filterList = filteringGuides;
    this.standardService.allStandardsFiltration.filterSet = filteringGuides;
  }
  compare(
    a: number | string | Date,
    b: number | string | Date,
    isAsc: boolean,
  ) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // sort function for equipment table
  sortEquipment(sort: Sort) {
    if (!sort.active || sort.direction === "" || !(this.grses.length > 0)) {
      return;
    }

    const isAsc = sort.direction === "asc";
    this.grses.sort((a, b) => {
      switch (sort.active) {
        case "equipmentType":
          return this.compare(
            a.equipmentStandard.equipmentType.name,
            b.equipmentStandard.equipmentType.name,
            isAsc,
          );
        case "supplier":
          return this.compare(
            a.equipmentStandard.supplier.name,
            b.equipmentStandard.supplier.name,
            isAsc,
          );
        case "title":
          return this.compare(a.title, b.title, isAsc);
        case "model":
          return this.compare(
            a.equipmentStandard.model,
            b.equipmentStandard.model,
            isAsc,
          );
        case "equipmentClass":
          return this.compare(
            a.equipmentStandard.equipmentClassType.name,
            b.equipmentStandard.equipmentClassType.name,
            isAsc,
          );
      }
    });
  }

  sortData(sort: Sort) {
    const rows = this.shouldIncludeMarketStandardsInOperations()
      ? this.mergedTableRows
      : this.standardsTableRows;
    if (!sort.active || sort.direction === "" || !(rows.length > 0)) {
      return;
    }

    const isAsc = sort.direction === "asc";
    const sortTarget = this.shouldIncludeMarketStandardsInOperations()
      ? this.mergedTableRows
      : this.standardsTableRows;
    sortTarget.sort((a, b) => {
      switch (sort.active) {
        case "title":
          return this.compare(a.title, b.title, isAsc);
        case "category":
          return this.compare(a.categoryName, b.categoryName, isAsc);
        case "desc":
          return this.compare(
            a.newRestaurantDescription || a.description,
            b.newRestaurantDescription || b.description,
            isAsc,
          );
      }
    });
    if (this.shouldIncludeMarketStandardsInOperations()) {
      this.updatePaginatedTableRows();
    }
  }
  rowSelected(item: Standard): void {
    this.standardService.fromLocationGRS = false;

    void 0;
    if (
      item.standardTypeId == StandardTypeEnum.GlobalMinimumRestaurantStandard
    ) {
      this.router.navigate(["/minimum-standard-detail-view/" + item.id]);
    } else if (item.standardTypeId == StandardTypeEnum.OperationsStandards) {
      this.router.navigate(["/operations-standards-detail-view/" + item.id]);
    } else if (
      item.standardTypeId == StandardTypeEnum.GlobalRecommendations ||
      item.standardTypeId == StandardTypeEnum.MarketBestPractices
    ) {
      this.router.navigate(["/global-recommendations-detail-view/" + item.id]);
    } else if (item.standardTypeId == 0) {
      this.router.navigate(["/view-equipments-standard-detail/" + item.id]);
    } else {
      // BU Standards (and anything else without its own dedicated detail page)
      // only ever appeared via the Market Standards/NRBES tab before, which
      // has its own row-click path (onTableRowSelected -> rowSelectedNrbes).
      // Now that they can also show up in the general grid, route by the
      // standard's own id to the same generic detail page the notification
      // feed already falls back to for unmapped standard types.
      this.router.navigate(["/view-standard-detail/" + item.id]);
    }
  }

  openDeleteModal(item, event) {
    event.stopPropagation();
    this.actionMenuOpen;
    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title =
      "Do you want to remove this standard from the list? ";
    if (
      item.standardTypeId == StandardTypeEnum.GlobalMinimumRestaurantStandard
    ) {
      modalRef.componentInstance.message =
        "All the dependencies will be removed along with this standard";
    }
    modalRef.componentInstance.deleteItem = item.id;
    this.trigger.closeMenu();
    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItemId) => {
      if (deleteItemId != null) {
        let grs = new SelectedStandard();
        grs.standard.id = deleteItemId;
        grs.standard.isDeleted = true;
        this.loading = true;
        this.standardService
          .removeGrbes(grs.standard)
          .subscribe((data: any) => {
            if (!data.status) {
              const modalRefd = this.ngbModal.open(FailModuleComponent);
              modalRefd.componentInstance.title =
                "You can't delete this standard!";
              modalRefd.componentInstance.errorMessage = data.message;
            }
            this.loading = false;
            this.page = 1;
            this.loadData();
          });
      }
      this.ngbModal.dismissAll();
    });
  }

  actionMenuOpen(event) {
    event.stopPropagation();
  }

  receivedFilteration($event) {
    this.isPageEnabled = false;
    this.filterList = $event;
    this.standardService.allStandardsFiltration.filterSet = this.filterList;
    // this.standardService.grsFiltration.filterSet = this.filterList;
    // this.standardService.minimumStandardFiltration.filterSet = this.filterList;
    // this.standardService.sharedLearingsFiltration.filterSet = this.filterList;
    // this.standardService.equipmentStandardFiltration.filterSet =
    //   this.filterList;
    // this.standardService.operationsStandardFiltration.filterSet =
    //   this.filterList;
    // this.standardService.nationalEquipmentStandardFiltration.filterSet =
    // this.filterList;
    // this.standardService.obsoleteStandardFiltration.filterSet = this.filterList;
    // this.standardService.locationGrsFiltration.filterSet = this.filterList;
    // this.standardService.upcomingStandardFiltration.filterSet = this.filterList;
    // this.standardService.nrbesFiltrations.filterSet = this.filterList;
    // this.standardService.equipmentAddendumFiltration.filterSet =
    //   this.filterList;

    // this.standardService.addendumFiltration.filterSet = this.filterList;

    this.pageSize = 10;
    this.page = 1;
    this.selectedRowsForExport = [];
    this.loadData();
  }

  closeMatMenuAndOpenDeleteModal(item, event) {
    this.trigger.closeMenu();
    setTimeout(() => {
      this.openDeleteModal(item, event);
    }, 100);
  }

  onSearchFromChild(searchValue: string) {
    // this.searchKey = searchValue;
    this.addSearchKey(searchValue);
  }

  addSearchKey(searchKey) {
    event?.preventDefault();
    this.searchKey = searchKey;
    this.page = 1;
    this.standardService.allStandardsFiltration.searchKey = this.searchKey;
    this.loadData();
  }

  onEdit(item: any) {
    this.activePopupId = null;
    this.standardService.standardEditPreviousRoute =
      this.activatedRoute.snapshot.routeConfig.path;

    const numericId = typeof item === "object" ? (item.id ?? item.standard?.id) : item;

    const tableRow =
      typeof item !== "object"
        ? this.standardsTableRows?.find(
            (r) => r.id === numericId || (r.isNrbesRow && r.nrbesId === numericId),
          )
        : item;
    const grsItem =
      typeof item !== "object"
        ? this.grses?.find((g) => g.id === numericId)
        : null;
    const nrbesItem =
      typeof item !== "object"
        ? this.nrbesItems?.find(
            (n) => n.id === numericId || n.standard?.id === numericId,
          )
        : null;

    const stdTypeId =
      (typeof item === "object"
        ? item.standardTypeId ?? item.standard?.standardTypeId
        : null) ??
      tableRow?.standardTypeId ??
      grsItem?.standardTypeId ??
      nrbesItem?.standard?.standardTypeId;

    if (
      stdTypeId === StandardTypeEnum.GlobalEquipmentStandard ||
      stdTypeId === StandardTypeEnum.LocalEquipmentStandard ||
      stdTypeId === 0
    ) {
      this.router.navigate(["/edit-eq-standards-global", numericId]);
    } else {
      this.router.navigate(["/add-grs", numericId]);
    }
  }

  onEditEquipment(id: any) {
    this.activePopupId = null;
    this.standardService.standardEditPreviousRoute =
      this.activatedRoute.snapshot.routeConfig.path;
    this.router.navigate(["/edit-eq-standards-global", id]);
  }

  downloadExcel() {
    this.handleExport();
  }

  handleExport(exportFilterList?: FilteringGuide[]): void {
    if (this.selectedRowsForExport.length > 0) {
      this.exportSelected();
      return;
    }

    if (this.shouldIncludeMarketStandardsInOperations()) {
      this.exportMergedTableRows();
      return;
    }

    this.isDownloading = true;
    const exportSize = Math.max(this.collectionSize, 1);
    const exportFilters = this.buildExportFilterList(exportFilterList);
    const exportCountryIds = this.getExportCountryIds(this.exportSelectedIds);

    if (this.isMarketStandardsTab()) {
      this.standardService
        .downloadExcel(
          0,
          exportSize,
          StandardListType.National,
          exportFilters,
          exportCountryIds?.length ? exportCountryIds : this.getCountryIdsForNrbesApi(),
          this.searchKey,
        )
        .subscribe({
          next: (response) =>
            this.saveExportFile(response, "Market_Standards_List"),
          error: (error) => this.handleExportError(error),
        });
      return;
    }

    this.standardService
      .downloadAllExcel(
        this.getAppliedFilters(),
        exportSize,
        exportFilters,
        this.searchKey,
        exportCountryIds,
      )
      .subscribe({
        next: (response) => this.saveExportFile(response, "All_Standards_List"),
        error: (error) => this.handleExportError(error),
      });
  }

  handleCountryList(countryList: number[]): void {
    this.exportSelectedIds = countryList ?? [];
  }

  buildExportFilterList(exportFilterList?: FilteringGuide[]): FilteringGuide[] {
    const tabFilter = this.standardService.allStandardsFiltration.filterSet.find(
      (filter) => filter.type === FilteringEnum.FilterByStandardType,
    );

    if (this.isMarketStandardsTab()) {
      const filters = (exportFilterList ?? []).filter(
        (filter) => filter.type !== FilteringEnum.FilterByStandardType,
      );
      filters.push(
        new FilteringGuide({
          type: FilteringEnum.FilterByStandardType,
          ids: [
            StandardTypeEnum.LocalStandard,
            StandardTypeEnum.ABUStandard,
          ],
        }),
      );
      return filters.length > 1 || exportFilterList?.length
        ? filters
        : this.getNrbesFilterList();
    }

    if (exportFilterList?.length) {
      const filters = [...exportFilterList];
      if (tabFilter) {
        filters.push(tabFilter);
      }
      return filters;
    }

    return this.standardService.allStandardsFiltration.filterSet;
  }

  getExportCountryIds(exportCountryIds: number[]): number[] | null {
    if (exportCountryIds?.length > 0) {
      return exportCountryIds;
    }
    return this.getCountryIdsForStandardsApi();
  }

  exportSelected(): void {
    let formattedData: Record<string, string | number>[] = [];

    if (this.isMarketStandardsTab()) {
      const selectedNrbes = this.nrbesItems.filter((item) =>
        this.selectedRowsForExport.includes(item.id),
      );
      if (selectedNrbes.length === 0) {
        const modalRef = this.ngbModal.open(FailModuleComponent);
        modalRef.componentInstance.errorMessage =
          "No selected standards to export.";
        return;
      }
      formattedData = selectedNrbes.map((item) => {
        const row: Record<string, string | number> = {
          "Standard ID": item.standard.id,
          Title: item.standard.title,
          Type: this.getStandardTypeLabel(item.standard.standardTypeId),
          Location: this.getNrbesLocationNames(item),
          Category: item.standard.category?.name ?? "",
          Description: item.standard.description || "",
        };
        if (this.shouldShowMarketStandardsCountryColumn()) {
          row.Country = this.getNrbesCountryName(item);
        }
        return row;
      });
    } else {
      const selectedData = this.grses.filter((item) =>
        this.selectedRowsForExport.includes(item.id),
      );
      if (selectedData.length === 0) {
        const modalRef = this.ngbModal.open(FailModuleComponent);
        modalRef.componentInstance.errorMessage =
          "No selected standards to export.";
        return;
      }
      formattedData = selectedData.map((item) => ({
        "Standard ID": item.id,
        Title: item.title,
        Type: this.getStandardTypeLabel(item.standardTypeId),
        Location: this.getLocationNames(item),
        Category: item.category?.name ?? "",
        Description: item.newRestaurantDescription || item.description || "",
      }));
    }

    this.writeExcelFile(
      formattedData,
      "Selected_Standards_List " + new Date().toLocaleString() + ".xlsx",
    );
  }

  exportMergedTableRows(): void {
    if (!this.mergedTableRows.length) {
      const modalRef = this.ngbModal.open(FailModuleComponent);
      modalRef.componentInstance.errorMessage = "No standards to export.";
      return;
    }

    const formattedData = this.mergedTableRows.map((row) => ({
      Title: row.title,
      Type: this.getStandardTypeLabel(row.standardTypeId),
      Location: row.locationText,
      Category: row.categoryName,
      Description: row.newRestaurantDescription || row.description || "",
    }));

    this.writeExcelFile(
      formattedData,
      "Operations_Standards_List " + new Date().toLocaleString() + ".xlsx",
    );
  }

  getStandardTypeLabel(standardTypeId: number): string {
    if (standardTypeId === StandardTypeEnum.GlobalMinimumRestaurantStandard) {
      return "Building Standards";
    }
    if (standardTypeId === StandardTypeEnum.OperationsStandards) {
      return "Operations Standards";
    }
    if (
      standardTypeId === StandardTypeEnum.GlobalRecommendations ||
      standardTypeId === StandardTypeEnum.MarketBestPractices
    ) {
      return "Global Approved Solutions";
    }
    if (standardTypeId === StandardTypeEnum.LocalStandard) {
      return "Market Standards";
    }
    if (standardTypeId === StandardTypeEnum.ABUStandard) {
      return "BU";
    }
    return "";
  }

  writeExcelFile(data: any[], fileName: string): void {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Standards");
    this.standardService.saveXlsxWorkbook(workbook, fileName);
  }

  saveExportFile(response: any, prefix: string): void {
    this.isDownloading = false;
    const filename = prefix + " " + new Date().toLocaleString();
    this.standardService.saveExportBlob(response, filename);
  }

  handleExportError(error: any): void {
    this.isDownloading = false;
    const modalRef = this.ngbModal.open(FailModuleComponent);
    modalRef.componentInstance.errorMessage = error.error
      ? error.error.Message
      : error.message;
  }

  downloadTabWiseExcel() {
    this.isTabWiseDownloading = true;
    this.standardService
      .downloadTabWiseExcel(
        this.getAppliedFilters(),
        this.collectionSize,
        this.standardService.allStandardsFiltration.filterSet,
        this.searchKey,
      )
      .subscribe(
        (response: any) => {
          this.isTabWiseDownloading = false;
          this.saveExportFile(response, "TabWise_Standards_List");
        },
        (error: any) => {
          this.isTabWiseDownloading = false;
          this.handleExportError(error);
        },
      );
  }
  getLocationNames(item): any {
    if (item.standardLocation && item.standardLocation.length > 0) {
      return item.standardLocation
        .map((loc) => loc.locationType.name)
        .join(", ");
    } else {
      return item.locationType.name;
    }
  }

  isSelected(id: number): boolean {
    return this.selectedRowsForExport.includes(id);
  }

  getSelectableRowsOnPage(): StandardsTableRow[] {
    return (this.standardsTableRows || []).filter((row) =>
      this.showStandardSelectionCheckbox(row),
    );
  }

  isAllOnPageSelected(): boolean {
    const selectable = this.getSelectableRowsOnPage();
    if (selectable.length === 0) {
      return false;
    }
    return selectable.every((row) =>
      this.isSelected(this.getRowSelectionKey(row)),
    );
  }

  isSomeOnPageSelected(): boolean {
    const selectable = this.getSelectableRowsOnPage();
    if (selectable.length === 0) {
      return false;
    }
    const selectedCount = selectable.filter((row) =>
      this.isSelected(this.getRowSelectionKey(row)),
    ).length;
    return selectedCount > 0 && selectedCount < selectable.length;
  }

  selectAllOnPageChange(event: any): void {
    const selectable = this.getSelectableRowsOnPage();
    if (event.checked) {
      selectable.forEach((row) => {
        const key = this.getRowSelectionKey(row);
        if (!this.selectedRowsForExport.includes(key)) {
          this.selectedRowsForExport.push(key);
        }
      });
    } else {
      selectable.forEach((row) => {
        const key = this.getRowSelectionKey(row);
        const index = this.selectedRowsForExport.indexOf(key);
        if (index > -1) {
          this.selectedRowsForExport.splice(index, 1);
        }
      });
    }
  }

  onCheckboxChange(event: any, id: number) {
    if (event.checked) {
      if (!this.selectedRowsForExport.includes(id)) {
        this.selectedRowsForExport.push(id);
        console.log("Added:", id);
      }
    } else {
      const index = this.selectedRowsForExport.indexOf(id);
      if (index > -1) {
        this.selectedRowsForExport.splice(index, 1);
      }
    }
  }
  extractDescription(description: string): string {
    const extracted = description.slice(0, 80);
    return extracted.length < description.length
      ? extracted + "..."
      : extracted;
  }
  togglePopup(event: MouseEvent, item: any): void {
    event.stopPropagation();
    // Close if clicking the same row, otherwise open new one
    this.activePopupId = this.activePopupId === item.id ? null : item.id;
  }

  goToNextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      if (
        this.shouldIncludeMarketStandardsInOperations() &&
        this.mergedTableRows.length
      ) {
        this.updatePaginatedTableRows();
      } else {
        this.loadData();
      }
    }
  }

  goToPreviousPage() {
    if (this.page > 1) {
      this.page--;
      if (
        this.shouldIncludeMarketStandardsInOperations() &&
        this.mergedTableRows.length
      ) {
        this.updatePaginatedTableRows();
      } else {
        this.loadData();
      }
    }
  }

  sortNrbesData(sort: Sort) {
    if (
      !sort.active ||
      sort.direction === "" ||
      !(this.nrbesItems.length > 0)
    ) {
      return;
    }

    const isAsc = sort.direction === "asc";
    this.nrbesItems.sort((a, b) => {
      switch (sort.active) {
        case "title":
          return this.compare(a.standard.title, b.standard.title, isAsc);
        case "category":
          return this.compare(
            a.standard.category.name,
            b.standard.category.name,
            isAsc,
          );
        case "desc":
          return this.compare(
            a.standard.description,
            b.standard.description,
            isAsc,
          );
      }
    });
  }

  rowSelectedNrbes(nrbesId: number): void {
    // The detail page (nrbes-view) reads its country/filter/search context from
    // this shared bucket rather than from route params - keep it in sync with
    // what's actually driving this tab's list, the same way nrbes-list.component.ts
    // already does for its own row navigation, so the detail lookup matches the
    // row that was actually clicked instead of whatever context was last left
    // behind by an unrelated page.
    this.standardService.nrbesFiltrations.filterSet = this.getNrbesFilterList();
    this.standardService.nrbesFiltrations.searchKey = this.searchKey;
    this.standardService.nrbesFiltrations.countryId =
      this.getCountryIdsForNrbesApi();
    this.router.navigate(["/nrbes-view/" + nrbesId]);
  }

  openDeleteModalNrbes(item, event) {
    event.stopPropagation();
    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title =
      "Do you want to remove this standard from the list? ";
    modalRef.componentInstance.deleteItem = item;

    modalRef.componentInstance.deletePopupEmit.subscribe((receivedEntry) => {
      if (receivedEntry != null) {
        this.loading = true;
        this.standardService
          .removeStandardFromNrbes(receivedEntry.id)
          .subscribe(() => {
            this.loading = false;
            this.page = 1;
            this.loadData();
          });
      }
      this.ngbModal.dismissAll();
    });
  }

  redirectToEditNrbes(standardId: number) {
    this.router.navigate(["edit-nrbes", standardId]);
  }

  addAddendum(standardId: number, event): void {
    this.addendumService.isCommingFromNrbes = false;
    this.addendumService.isCommingFromAllStandards = true;
    this.addendumService.isCommingFromNationalEquipmentList = false;
    event.stopPropagation();
    this.router.navigate(["/add-addendum/" + standardId]);
  }

  goToAddendum(nrbesItem: any): void {
    try {
      this.storage.set("adCountryId", nrbesItem.country);
      this.router.navigate(["/addendum/" + nrbesItem.availabileAddendumId]);
    } catch (e) {
      void 0;
    }
  }

  onBasicUserGoToException(item: NrbesItem, event: MouseEvent): void {
    event.stopPropagation();
    this.addendumService.isCommingFromNrbes = true;
    this.goToAddendum(item);
  }

  getNrbesLocationNames(item): any {
    if (
      item.standard.standardLocation &&
      item.standard.standardLocation.length > 0
    ) {
      return item.standard.standardLocation
        .map((loc) => loc.locationType.name)
        .join(", ");
    }
    return item.standard.locationType?.name ?? "";
  }

  getStandardIcon(id: number) {
    if (id === 4) {
      return '/assets/images/building-standrad.svg';
    } else if (id == 8) {
      return '/assets/images/operation-standard.svg'
    } else if (id == 3 || id == 7) {
      return '/assets/images/list 1.svg';
    } else {

      return '/assets/images/global approved icon.svg';
    }

  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;


    if (!target.closest('.grid-actions')) {
      this.activePopupId = null;
    }


  }

}
